// extracted by mini-css-extract-plugin
export default {"container":"container__eI1SX","module":"module__ojsbw","image":"image__DVIen","image-MEGA_MENU_VENDORS_1_CONTROL":"image-MEGA_MENU_VENDORS_1_CONTROL___mx9f","label":"label__B8iKL"};